// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.blue-shadow {\r\n  filter: drop-shadow(0 0 3px #076fb6);\n}\r\n", ""]);
// Exports
module.exports = exports;
